module.exports = __webpack_public_path__ + "img/map-pins-white.f43fa0aa.svg";